export const JOURNAL_ECRITURE = {
  lecture: { module: 'comptabilite', element: 'journal_ecriture', rule: 'lecture' },
  maj: { module: 'comptabilite', element: 'journal_ecriture', rule: 'maj' },
  exporter: { module: 'comptabilite', element: 'journal_ecriture', rule: 'exporter' },
  supprimer: { module: 'comptabilite', element: 'journal_ecriture', rule: 'supprimer' },
  editer: { module: 'comptabilite', element: 'journal_ecriture', rule: 'edition' },
};

export const LOTS_COMPTABLE = {
  lecture: { module: 'comptabilite', element: 'lots_comptable', rule: 'lecture' },
  maj: { module: 'comptabilite', element: 'lots_comptable', rule: 'maj' },
  exporter: { module: 'comptabilite', element: 'lots_comptable', rule: 'exporter' },
  supprimer: { module: 'comptabilite', element: 'lots_comptable', rule: 'supprimer' },
};

export const SITUATION = {
  lecture: { module: 'comptabilite', element: 'situation', rule: 'lecture' },
  maj: { module: 'comptabilite', element: 'situation', rule: 'maj' },
  exporter: { module: 'comptabilite', element: 'situation', rule: 'exporter' },
  supprimer: { module: 'comptabilite', element: 'situation', rule: 'supprimer' },
};

export const OPERATION_DIVERSE = {
  lecture: { module: 'comptabilite', element: 'operation_diverse', rule: 'lecture' },
  maj: { module: 'comptabilite', element: 'operation_diverse', rule: 'maj' },
  exporter: { module: 'comptabilite', element: 'operation_diverse', rule: 'exporter' },
  supprimer: { module: 'comptabilite', element: 'operation_diverse', rule: 'supprimer' },
};
export const ECRITURE_COMPTABLE = {
  lecture: { module: 'comptabilite', element: 'ecriture_comptable', rule: 'lecture' },
  maj: { module: 'comptabilite', element: 'ecriture_comptable', rule: 'maj' },
  exporter: { module: 'comptabilite', element: 'ecriture_comptable', rule: 'exporter' },
  supprimer: { module: 'comptabilite', element: 'ecriture_comptable', rule: 'supprimer' },
};
